import React, { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import Header from './Header';
import Sidebar from './Sidebar';
import PricingModal from '../subscription/PricingModal';
import { Category, Tag } from '../../types';

interface LayoutProps {
  children: React.ReactNode;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSearch: (query: string) => void;
  categories: Category[];
  categoriesLoading: boolean;
  selectedCategory: number | null;
  onSelectCategory: (categoryId: number | null) => void;
  tags: Tag[];
  tagsLoading: boolean;
  selectedTags: string[];
  onToggleTag: (tagName: string) => void;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  searchValue,
  onSearchChange,
  onSearch,
  categories,
  categoriesLoading,
  selectedCategory,
  onSelectCategory,
  tags,
  tagsLoading,
  selectedTags,
  onToggleTag,
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showPricingModal, setShowPricingModal] = useState(false);

  const handleMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleSidebarClose = () => {
    setIsMobileMenuOpen(false);
  };

  const handleOpenPricing = () => {
    setShowPricingModal(true);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 헤더 */}
      <Header
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        onSearch={onSearch}
        onMenuToggle={handleMenuToggle}
        isMobileMenuOpen={isMobileMenuOpen}
        onOpenPricing={handleOpenPricing}
      />

      <div className="flex">
        {/* 사이드바 */}
        <Sidebar
          isOpen={isMobileMenuOpen}
          onClose={handleSidebarClose}
          categories={categories}
          categoriesLoading={categoriesLoading}
          selectedCategory={selectedCategory}
          onSelectCategory={onSelectCategory}
          tags={tags}
          tagsLoading={tagsLoading}
          selectedTags={selectedTags}
          onToggleTag={onToggleTag}
        />

        {/* 메인 컨텐츠 */}
        <main className="flex-1">
          <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6 py-4">
            {children}
          </div>
        </main>
      </div>

      {/* 프라이싱 모달 */}
      <PricingModal
        isOpen={showPricingModal}
        onClose={() => setShowPricingModal(false)}
      />

      {/* 토스트 알림 */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            style: {
              background: '#10B981',
            },
          },
          error: {
            style: {
              background: '#EF4444',
            },
          },
        }}
      />
    </div>
  );
};

export default Layout;